const FinesTab = ({ fines, setSelectedFine, setShowFineDetailModal, setShowFineResponseModal, darkMode }) => {
  const getInfractionLabel = (type) => {
    const labels = {
      'speeding': 'Excesso de Velocidade',
      'parking': 'Estacionamento Indevido',
      'red_light': 'Sinal Vermelho',
      'phone': 'Uso de Telemóvel',
      'seatbelt': 'Cinto de Segurança',
      'alcohol': 'Álcool/Drogas'
    };
    return labels[type] || type || 'Coima';
  };

  const getStatusInfo = (status) => {
    const statusMap = {
      'pending_response': { label: 'Pendente Resposta', color: 'bg-red-500 text-white' },
      'awaiting_payment': { label: 'Aguarda Pagamento', color: 'bg-amber-500 text-white' },
      'salary_deduction_pending': { label: 'Dedução Salarial', color: 'bg-orange-500 text-white' },
      'paid': { label: 'Pago', color: 'bg-emerald-500 text-white' },
      'contested': { label: 'Contestado', color: 'bg-purple-500 text-white' }
    };
    return statusMap[status] || { label: status, color: 'bg-slate-500 text-white' };
  };

  const getCardStyle = (status) => {
    if (status === 'pending_response') {
      return darkMode ? 'bg-red-900/20 border-red-700' : 'bg-red-50 border-red-200';
    }
    if (status === 'awaiting_payment') {
      return darkMode ? 'bg-amber-900/20 border-amber-700' : 'bg-amber-50 border-amber-200';
    }
    if (status === 'paid') {
      return darkMode ? 'bg-emerald-900/20 border-emerald-700' : 'bg-emerald-50 border-emerald-200';
    }
    return darkMode ? 'bg-slate-700/50 border-slate-600' : 'bg-slate-100 border-slate-200';
  };

  return (
    <div>
      <h3 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-slate-800'}`}>Coimas / Multas de Viaturas</h3>
      
      {fines.length === 0 ? (
        <div className="text-center py-8">
          <span className="text-4xl block mb-4">✅</span>
          <p className={darkMode ? 'text-slate-400' : 'text-slate-500'}>Sem coimas pendentes</p>
        </div>
      ) : (
        <div className="space-y-4">
          {fines.map((fine, idx) => {
            const statusInfo = getStatusInfo(fine.status);
            return (
              <div key={idx} className={`p-4 rounded-lg border ${getCardStyle(fine.status)}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xl">⚠️</span>
                      <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>
                        {getInfractionLabel(fine.infraction_type)}
                      </p>
                      <span className={`px-2 py-0.5 rounded text-xs font-medium ${statusInfo.color}`}>
                        {statusInfo.label}
                      </span>
                    </div>
                    
                    <div className="grid md:grid-cols-2 gap-2 mb-3">
                      <div>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Viatura:</span> {fine.license_plate}
                        </p>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Data:</span> {fine.fine_date} {fine.fine_time && `às ${fine.fine_time}`}
                        </p>
                      </div>
                      <div>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Local:</span> {fine.location || '-'}
                        </p>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Entidade:</span> {fine.authority || '-'}
                        </p>
                      </div>
                    </div>
                    
                    {fine.infraction_description && (
                      <p className={`text-sm mb-2 ${darkMode ? 'text-slate-300' : 'text-slate-600'}`}>{fine.infraction_description}</p>
                    )}
                    
                    <div className="flex items-center gap-4">
                      <p className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>{fine.amount?.toFixed(2)} €</p>
                      {fine.points_deducted > 0 && (
                        <span className="text-sm text-red-500">-{fine.points_deducted} pontos</span>
                      )}
                      {fine.payment_deadline && (
                        <span className={`text-xs ${darkMode ? 'text-red-400' : 'text-red-600'}`}>Prazo: {fine.payment_deadline}</span>
                      )}
                      {fine.documents?.length > 0 && (
                        <span className={`text-xs px-2 py-0.5 rounded ${darkMode ? 'bg-blue-900/30 text-blue-400' : 'bg-blue-100 text-blue-700'}`}>
                          📎 {fine.documents.length} documento(s)
                        </span>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex flex-col gap-2 ml-4">
                    <button
                      onClick={() => { setSelectedFine(fine); setShowFineDetailModal(true); }}
                      className={`px-4 py-2 rounded-lg text-sm transition-colors ${
                        darkMode ? 'bg-slate-600 text-white hover:bg-slate-500' : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
                      }`}
                      data-testid={`view-fine-${fine.fine_id}`}
                    >
                      Ver Detalhes
                    </button>
                    {fine.status === 'pending_response' && (
                      <button
                        onClick={() => { setSelectedFine(fine); setShowFineResponseModal(true); }}
                        className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-500 transition-colors"
                        data-testid={`respond-fine-${fine.fine_id}`}
                      >
                        Responder
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FinesTab;
